import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../utils/date';
import { HorseLink } from '../../../shared/links/ProfileLink';

const FamilyLeaf = ({ data }) => {
    if (data && data.horseName) {
        const { horseUid, horseName, countryOriginCode, horseDateOfBirth } = data;
        return (
            <HorseLink
                className="hp-familyTree__block"
                horseUid={horseUid}
                horseStyleName={horseName}
            >
                <span className="hp-familyTree__block__name">
                    <span className="hp-familyTree__block__horseName">
                        { horseName }
                        <span className="hp-familyTree__block__code">
                            {` (${countryOriginCode}) `}
                        </span>
                    </span>
                    <span className="hp-familyTree__block__yob">
                        { horseDateOfBirth && formatDate(horseDateOfBirth, 'YYYY') }
                    </span>
                </span>
            </HorseLink>
        );
    }
    return <span className="hp-familyTree__block" />;
};

FamilyLeaf.propTypes = {
    data: PropTypes.shape({
        countryOriginCode: PropTypes.string,
        horseDateOfBirth: PropTypes.string,
        horseName: PropTypes.string,
        horseUid: PropTypes.number,
    }),
};

export default FamilyLeaf;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/familyTree/FamilyLeaf.jsx